import React from "react";
import track from "react-tracking";
import { useNavigate } from "react-router-dom";

import { Box, Button, Stack } from "@metrea-ui/v2";
import { PageHeader } from "../components/SiteLayout/Header";
import { PageFooter } from "../components/SiteLayout/Footer";
import Users from "../components/User/Users";
import EditUser from "../components/User/EditUser";
import UserGroups from "../components/UserGroup/UserGroups";
import UserActivities from "../components/UserActivity/UserActivities";

import { Session, isDevTeam, isDeveloper } from "../utils/sessionUtils";

const Admin_Page = () => {
	let navigate = useNavigate();

	const menuClickHandler = (e) => {
		let text = e.target.innerText;

		switch (text) {
			case "User Management":
				navigate("/admin/user");
				break;

			case "User Group Management":
				navigate("/admin/usergroup");
				break;

			case "User Activity":
				navigate("/admin/activity");
				break;

			default:
				break;
		}
	};

	return (
		<>
			<PageHeader pageTitle="Administrator" />
			<Box className="pageContent">
				<Box w="50%">
					<Stack p={10} gap={10}>
						<Button onClick={menuClickHandler}>User Management</Button>
						{isDevTeam() && <Button onClick={menuClickHandler}>User Activity</Button>}
						{isDeveloper() && <Button onClick={menuClickHandler}>User Group Management</Button>}
					</Stack>
				</Box>
				<PageFooter />
			</Box>
		</>
	);
};

const User_Page = () => {
	return (
		<>
			<Users />
		</>
	);
};

const MyProfile_Page = (props) => {
	return (
		<>
			<PageHeader pageTitle="My Profile" />
			<Box className="pageContent">
				<EditUser callFrom="myProfile" mode="edit" item={Session().currUser} />
				<PageFooter />
			</Box>
		</>
	);
};

const UserGroup_Page = () => {
	return (
		<>
			<UserGroups />
		</>
	);
};

const UserActivity_Page = () => {
	return (
		<>
			<UserActivities />
		</>
	);
};

export const Admin = track(
	{ page: "Admin" },
	{ dispatchOnMount: (contextData) => ({ event: "pageLoaded" }) },
)(Admin_Page);

export const User = track(
	{ page: "User" },
	{ dispatchOnMount: (contextData) => ({ event: "pageLoaded" }) },
)(User_Page);

export const MyProfile = track(
	{ page: "MyProfile" },
	{ dispatchOnMount: (contextData) => ({ event: "pageLoaded" }) },
)(MyProfile_Page);

export const UserGroup = track(
	{ page: "UserGroup" },
	{ dispatchOnMount: (contextData) => ({ event: "pageLoaded" }) },
)(UserGroup_Page);

export const UserActivity = track(
	{ page: "UserActivity" },
	{ dispatchOnMount: (contextData) => ({ event: "pageLoaded" }) },
)(UserActivity_Page);
